<div class="fake-icon">?</div>
<p>
  {{ 'Connecting to TrueNAS... Make sure the TrueNAS system is powered on and connected to the network.' | translate }}
</p>
